import { Component } from '@angular/core';
import { PanelListConstants } from '../../shared/constants/panel-list-constants';
import { BptEmptyFeedbackResultsModule } from "bpt-ui-library/bpt-empty-feedback-results";

@Component({
  selector: 'app-empty-results',
  standalone: true,
  imports: [BptEmptyFeedbackResultsModule],
  templateUrl: './empty-results.component.html',
  styleUrls: ['./empty-results.component.scss'],

})
export class EmptyResultsComponent {
  noResultStatus = PanelListConstants.NoResultStatus;
  noResultMessage = PanelListConstants.NoResultMessage;
  noResultSubTitle = PanelListConstants.NoResultSubTitle;
  noResultDisplayButtons = PanelListConstants.NoResultDisplayButtons

}
